import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../Layout';
import Text from '../Text';

const LabelText = ({ text, label }) => (
  <Box  style={{display: 'flex', flexDirection: 'column', padding:10}} >
    <Text variant="h2">{label}</Text>
    <Text variant="h5">{text}</Text>
  </Box>
);

LabelText.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default LabelText;
